import type { CSSProperties } from 'react';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';

const BUTTON_SIZE = 36;

const scrollToBottomButtonStyle: Record<'wrapper' | 'visible' | 'hidden', CSSProperties> = {
  wrapper: {
    position: 'absolute',
    bottom: 12,
    right: 16,
    zIndex: 10,
    transition: 'opacity 200ms ease, transform 200ms ease',
  },
  visible: {
    opacity: 1,
    transform: 'translateY(0)',
    pointerEvents: 'auto',
  },
  hidden: {
    opacity: 0,
    transform: 'translateY(8px)',
    pointerEvents: 'none',
  },
};

type ScrollToBottomButtonProps = {
  visible: boolean;
  onClick: () => void;
  trackingIdPrefix?: string;
};

export const ScrollToBottomButton = ({ visible, onClick, trackingIdPrefix }: ScrollToBottomButtonProps) => {
  return (
    <div
      style={{
        ...scrollToBottomButtonStyle.wrapper,
        ...(visible ? scrollToBottomButtonStyle.visible : scrollToBottomButtonStyle.hidden),
      }}
    >
      <Button
        iconName='caret-down'
        variant='secondary'
        onClick={onClick}
        size='small'
        css={{
          width: BUTTON_SIZE,
          height: BUTTON_SIZE,
          padding: 0,
          borderRadius: '50%',
          backgroundColor: theme.colors.neutral5,
          border: `1px solid ${theme.colors.neutral10}`,
          boxShadow: theme.shadows.light,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          svg: {
            color: theme.colors.neutral70,
          },
          ':hover': {
            backgroundColor: theme.colors.neutral5,
            boxShadow: theme.shadows.floating,
          },
        }}
        data-trackingid={trackingIdPrefix ? `${trackingIdPrefix}-scroll-to-bottom` : undefined}
      />
    </div>
  );
};
